import React, { useContext } from "react";
import './CalendarGridYear.css';
import { getShownDates } from "./CalendarUtils";
import { days, monthNames, getLocalizedDays, getLocalizedMonthNames } from "../../utils/dateFormats";
import { ITicket } from "../../types/dashboard";
import { AppContext } from "../../appContext";

interface ICalendarGridYearProps {
    baseDate?: Date,
    tickets: ITicket[],
    onMonthClick: (date: Date)=>void,
    onDayClick: (date: Date)=>void
}

export const CalendarGridYear = ({baseDate: _baseDate, tickets, onMonthClick, onDayClick}: ICalendarGridYearProps)=>{
    const baseDate = _baseDate || new Date();
    const currentYear = baseDate.getUTCFullYear();
    const yearDates = new Array(12).fill(null).map((it, i)=>{
        const monthDate = new Date(0);
        monthDate.setUTCFullYear(currentYear);
        monthDate.setUTCMonth(i);
        return getShownDates(monthDate);
    });
    const {translate} = useContext(AppContext);
    const localizedMonthNames = getLocalizedMonthNames(translate);
    const localizedDays = getLocalizedDays(translate);
    return (
        <div className="scroll calendarGridYear_wrap">
            <div className="calendarGridYear_header">
                <h2 className="calendarGridYear_date">{currentYear}</h2>
            </div>
            <div className="calendarGridYear">
                {yearDates.map((month, monthIndex)=>{
                    return <div className="calendarGridYear_month">
                        <div className="button calendarGridYear_month_name" onClick={()=>{
                            const monthDate = new Date(0);
                            monthDate.setUTCFullYear(currentYear);
                            monthDate.setUTCMonth(monthIndex);
                            onMonthClick(monthDate);
                        }}>
                            {localizedMonthNames[monthIndex]}
                        </div>
                        <div className="calendarGridYear_month_dates">
                            {localizedDays.map((dayName, dayIndex)=>{
                                return <div className="calendarGridYear_month_day calendarGridYear_month_day--name">
                                    {dayName.toUpperCase()}
                                </div>
                            })}
                            {month.map((dayDate, dayIndex)=>{
                                const foundTickets = tickets.filter(kt=>{
                                    const start = new Date(dayDate);
                                    const end = new Date(dayDate);
                                    end.setUTCDate(dayDate.getUTCDate()+1);
                                    //console.log(start.valueOf(), end.valueOf(), kt.start.valueOf(), start <= kt.start, end >= kt.start, start.valueOf() - kt.start.valueOf(),  end.valueOf() - kt.start.valueOf());
                                    return start <= kt.start && end > kt.start
                                });
                                return dayDate.getUTCMonth() == monthIndex ? <div className="button calendarGridYear_month_day calendarGridYear_month_day_clickable" onClick={()=>{
                                    onDayClick(dayDate)
                                }}>
                                    {foundTickets.length ? <div className="calendarGridYear_dayWithTicket">{foundTickets.length}</div> : ""}
                                    <div className="calendarGridYear_month_day_number">
                                        {dayDate.getUTCDate()}
                                    </div>
                                </div> : <div className="calendarGridYear_month_day"></div>
                            })}
                        </div>
                    </div>
                })}
            </div>
        </div>
    )
}